import i18n from 'locales/fa.json';
import {
  SpecialPackageTableDataType,
  SpecialPackageType,
} from 'typings/specialPackages.type';
import {
  convertDatePickerStringToObject,
  convertToJalaliDate,
} from './common.util';

export const normalizeChartData = (
  chartData: (string | number)[][],
): { basketReturn: number; indexReturn: number; date: string }[] =>
  chartData.map((item) => ({
    indexReturn: item[0] as number,
    basketReturn: item[1] as number,
    date: item[2] as string,
  }));

// change date to jalali and normalize special package data based on jalali date
export const normalizeData = (
  tableData: SpecialPackageTableDataType,
  isPurchasedBaskets: boolean,
): { [key: string]: SpecialPackageType[] } => {
  const baskets = {};

  tableData?.baskets.forEach((item) => {
    const updatedItem = {
      ...item,
      published_date: convertToJalaliDate(item.published_date),
    };
    const publishedDate = convertDatePickerStringToObject(
      updatedItem.published_date,
    );
    const date = `${i18n.global.monthPicker.months[publishedDate.month - 1]} ${
      i18n.global.month
    } ${publishedDate.year}`;
    // normalize special package data based on date
    // {[...,{},{}] :دی ماه 1400}
    if (isPurchasedBaskets) {
      // open baskets contain the basket data has file_path
      if (!baskets[date] && !!updatedItem.file_path) {
        baskets[date] = [];
      }
      !!updatedItem.file_path && baskets[date].push(updatedItem);
    } else {
      if (!baskets[date]) {
        baskets[date] = [];
      }
      baskets[date].push(updatedItem);
    }
  });
  return baskets;
};
